export default __webpack_public_path__ + "0c3b8929d377c0e9b2f3a9c872e3337b.woff";